import { List, Typography } from 'antd';
import { PhoneFilledIcon } from 'assets';
import dayjs from 'dayjs';
import { random } from 'lodash';
import React, { memo, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import { CallSessionDto } from 'types';
import { CALL_SESSION_OPTION, CALL_SESSION_TYPE, CALL_SOURCE_OPTION } from 'utils';

type AICallHistoryItemProps = {
  item: CallSessionDto;
  selected?: boolean;
  onSelect?: () => void;
};

const AICallHistoryItem: React.FC<AICallHistoryItemProps> = ({ item, selected, onSelect }) => {
  const sourceData = item.callSource ? CALL_SOURCE_OPTION[item.callSource as keyof typeof CALL_SOURCE_OPTION] : null;

  return (
    <div
      className={twMerge(
        'flex w-full cursor-pointer gap-4 px-5 py-3 hover:bg-colorBgItemHover',
        selected && 'bg-colorBgItemHover'
      )}
      onClick={onSelect}
    >
      <div>
        <div
          className={twMerge('flex h-12 w-12 items-center justify-center rounded-full border bg-white transition-all')}
          style={{
            borderColor: '#1564E8'
          }}
        >
          <PhoneFilledIcon color='#1564E8' className='h-6 w-6' />
        </div>
      </div>
      <div className='mt-[3px] flex-1'>
        <div className='mb-1 flex items-center gap-2'>
          <Typography.Text className='font-semibold leading-5'>{item.customerPhoneNumber}</Typography.Text>
          <span className='rounded-[3px] border px-1.5 text-xs uppercase leading-5' style={sourceData?.tagStye}>
            {item.callSource}
          </span>
        </div>
        <Typography.Paragraph className='mb-0 text-sm text-colorTextPlaceholder'>AI</Typography.Paragraph>
      </div>
      <div className='mt-[3px] flex flex-col gap-1.5'>
        <Typography.Text className='text-end text-xs' type='secondary'>
          {dayjs(item.endAt).format('DD/MM')}
        </Typography.Text>

        <Typography.Text className='text-end text-sm'>
          {(() => {
            const totalMinutes = dayjs(item.endAt).diff(dayjs(item.receivedAt), 'minute');
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            if (hours > 0) {
              return minutes > 0 ? `${hours}h${minutes}p` : `${hours}h`;
            }
            return `${minutes}p`;
          })()}
        </Typography.Text>
      </div>
    </div>
  );
};

export default memo(AICallHistoryItem);
